import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="py-24">
      <div className="container max-w-2xl text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-9xl font-bold text-gray-200 dark:text-gray-700">404</div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Page Not Found</h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have been moved or
          deleted.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors"
          >
            <Home className="h-5 w-5" />
            Go to Help Center
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </button>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-12 border-t border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Helpful Links</h2>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Browse Categories
            </Link>
            <span className="text-gray-300">|</span>
            <Link
              to="/search"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Search Articles
            </Link>
            <span className="text-gray-300">|</span>
            <Link
              to="/submit-ticket"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Submit a Request
            </Link>
            <span className="text-gray-300">|</span>
            <Link
              to="/my-tickets"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              My Tickets
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
